var chunkMapping = {
	"84": [
		4084
	],
	"371": [
		37371
	],
	"383": [
		68383
	],
	"417": [
		63417
	],
	"441": [
		10441
	],
	"531": [
		85531
	],
	"998": [
		93998
	]
};
var idToExternalAndNameMapping = {
	"4084": [
		"default",
		"./Configuration",
		68149
	],
	"10441": [
		"default",
		"./Template",
		1576
	],
	"37371": [
		"default",
		"./Category",
		1576
	],
	"63417": [
		"default",
		"./BmkStaticContentTranslation",
		1576
	],
	"68383": [
		"default",
		"./TarServices",
		68149
	],
	"85531": [
		"default",
		"./Translation",
		68149
	],
	"93998": [
		"default",
		"./BMKLanguageService",
		1576
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}